import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { PosPlugin } from 'plugins/plugin';

import { getTafReduxState } from '../rdx/reducers';

const UICustomerSearch: PosPlugin['UICustomerSearch'] = ({
  children,
  setSearchValue,
}) => {
  const { applyTafLogic } = useSelector(getTafReduxState);

  useEffect(() => {
    if (applyTafLogic) {
      setSearchValue('   ');
    }
  }, [applyTafLogic]);

  return children;
};

export default UICustomerSearch;
